<mat-dialog-content class="p-6">
  <form form [formGroup]="form">
    <p mat-dialog-title class="text-lg pb-1 mx-auto">
      {{ dialogType() }}
    </p>
    <span class="flex flex-col gap-2 justify-center items-center mt-4 w-full">
      @if(form.get('price_type').value === priceTypes.Cash){
      <span
        class="flex flex-row mobile-max:w-full mobile-max:flex-col justify-center items-center gap-1 w-full"
      >
        <mat-form-field
          appearance="outline"
          formGroupName="cash_price"
          class="w-full"
        >
          <mat-label>Price</mat-label>
          <input
            #myInput
            matInput
            type="number"
            formControlName="amount"
            style="text-align: center !important"
            [placeholder]="form.get('cash_price').get('amount').value"
            #input
          />
          @if( (form.get('cash_price').get('amount').dirty ||
          form.get('cash_price').get('amount').touched ) &&
          form.get('cash_price').get('amount').hasError('pattern') &&
          form.get('price_type').value === 'Cash' ){
          <mat-error class="text-xs">
            Should not exceed 4 decimal places
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Volume</mat-label>
          <input
            matInput
            type="number"
            formControlName="volume_value"
            style="text-align: center !important"
            #input
          />
        </mat-form-field>
      </span>
      } @else if(form.get('price_type').value === priceTypes.Basis){

      <div
        class="w-full flex flex-col flex-wrap gap-2"
        formGroupName="basis_price"
      >
        <div
          class="basis_price flex flex-row gap-x-3 justify-center items-center tablet-max:flex-wrap"
        >
          <mat-form-field class="tablet-max:w-full">
            <mat-label>Basis Points</mat-label>
            <input
              type="number"
              formControlName="basisPoints"
              matInput
              [errorStateMatcher]="matcher"
            />
          </mat-form-field>
          <mat-form-field class="tablet-max:w-full">
            <mat-label>Product Code </mat-label>
            <input
              type="text"
              formControlName="product_code"
              matInput
              [readonly]="true"
              [errorStateMatcher]="matcher"
            />
          </mat-form-field>
        </div>
        <div
          class="flex flex-row w-full justify-center gap-x-3 items-center tablet-max:flex-wrap"
        >
          <mat-form-field class="tablet-max:w-full">
            <mat-label>Month</mat-label>
            <mat-select formControlName="month">
              @for(month of basisMonths; track $index){
              <mat-option [value]="month.value" class="text-sm"
                >{{ month.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="tablet-max:w-full">
            <mat-label>Year</mat-label>
            <mat-select formControlName="year">
              @for(year of basisYears; track $index){
              <mat-option [value]="year">{{ year }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="flex flex-row gap-2 tablet-max:flex-col justify-center items-center w-full"
      >
        <mat-form-field class="tablet-max:w-full">
          <mat-label>Basis Quote</mat-label>
          <input
            [readonly]="true"
            type="text"
            matInput
            [value]="basisQuote()"
            [errorStateMatcher]="matcher"
          />
        </mat-form-field>
        <mat-form-field class="tablet-max:w-full">
          <mat-label>Volume (MT)</mat-label>
          <input
            type="number"
            matInput
            placeholder="100"
            formControlName="volume_value"
          />
        </mat-form-field>
      </div>
      }

      <span class="flex flex-col justify-center items-center gap-y-2 w-full">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Delivery Window</mat-label>
          <mat-date-range-input [rangePicker]="picker" [min]="minDate">
            <input
              matStartDate
              formControlName="ship_begin"
              placeholder="Start date"
              [errorStateMatcher]="matcher"
            />
            <input
              matEndDate
              formControlName="ship_end"
              placeholder="End date"
              [errorStateMatcher]="matcher"
            />
          </mat-date-range-input>
          <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker touchUi #picker></mat-date-range-picker>
        </mat-form-field>
        @if(dialogType() === dialogTypes.Counter){
        <span class="dark:text-white text-xs text-width"
          >Negotiations are subject to expiration similar to lots. Negotiations
          for day orders will expire at the conclusion of the active trading
          day, while negotiations for GTC (Good Until Canceled) orders will
          persist until manually withdrawn by the lot creator.</span
        >
        }
      </span>
      <div
        class="dark:text-white text-xs flex flex-row justify-center items-center text-center zgap-2"
      ></div>
    </span>
    <div
      class="error px-2 py-1 text-sm mb-4 text-center"
      [class.hide]="!form.hasError('sameValues')"
    >
      <mat-error
        class="input-error"
        [ngClass]="{ show: form.hasError('priceRequired') }"
        >Enter a valid price</mat-error
      >
      <mat-error
        class="input-error"
        [ngClass]="{
          show:
            form.get('volume_value').hasError('required') ||
            form.get('volume_value').hasError('pattern')
        }"
      >
        Enter a valid Volume value
      </mat-error>
      <mat-error
        class="input-error"
        [ngClass]="{
          show:
            form.get('price_type').value === priceTypes.Basis &&
            form.get('basis_price.basisPoints').hasError('pattern')
        }"
      >
        Basis points should not exceed 4 decimal places
      </mat-error>
    </div>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
      <div class="flex flex-row justify-end gap-2">
        <button class="revoke-btn" mat-raised-button (click)="close(false)">
          Cancel
        </button>
        <button
          (click)="close(true)"
          class="text-sm"
          [ngClass]="{
            'disabled-btn': form.invalid,
            'counter-btn':
              !form.invalid && dialogType() === dialogTypes.Counter,
            'disable-btn': !form.invalid,
            'offer-btn': dialogType() === dialogTypes.Edit
          }"
          [disabled]="form.invalid"
          mat-raised-button
        >
          {{ dialogType() === dialogTypes.Counter ? "Counter" : "Save" }}
        </button>
      </div>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
